import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { modalActionType } from 'utils/constants';
import ExportKpiReport from './ExportKpiReport';
import DrillDownKpiModal from './DrillDownKpiModal';
import ViewKpiReport from './ViewKpiReport';

const ModalsContent = () => {
  const action = useSelector(selectors.modal.getActionType);

  switch (action) {
    case modalActionType.controlTower.EXPORT_KPI_REPORT:
      return <ExportKpiReport />;
    case modalActionType.controlTower.VIEW_KPI_REPORT:
      return <ViewKpiReport />;
    case modalActionType.controlTower.DRILL_DOWN_KPI:
      return <DrillDownKpiModal />;
    default:
      return null;
  }
};

export default ModalsContent;
